// extracted by mini-css-extract-plugin
module.exports = {"bulletinItem":"BulletinItem_bulletinItem_2cEsH","bulletin":"BulletinItem_bulletin_2lqSK"};